export const dataManagementTexts = {
  title: 'Data Management',
  description:
    "Sweep's Data Management Plugin simplifies your funnel management. Drag and drop to add date/time fields and ownership tracking to your steps. Gain valuable insights and optimize your sales process effortlessly.",
};
